export const SHIPMENT_CREATE = "CREATE-SHIPMENT";
export const ORDER_CREATE = "ORDER_CREATE";
export const DELIVERY_CREATE = "DELIVERY_CREATE";
export const PRODUCT_CREATE = "PRODUCT_CREATE";
export const SHIPMENT_UPDATE = "SHIPMENT_UPDATE";
export const ORDER_UPDATE = "ORDER_UPDATE";
export const DELIVERY_UPDATE = "DELIVERY_UPDATE";
export const PRODUCT_UPDATE = "PRODUCT_UPDATE";
export const SHIPMENT_DELETE = "SHIPMENT_DELETE";
export const ORDER_DELETE = "ORDER_DELETE";
export const DELIVERY_DELETE = "DELIVERY_DELETE";
export const PRODUCT_DELETE = "PRODUCT_DELETE";
export const SHIPMENT_READ = "SHIPMENT_READ";
export const ORDER_READ = "ORDER_READ";
export const DELIVERY_READ = "DELIVERY_READ";
export const PRODUCT_READ = "PRODUCT_READ";
